/**
 * Team ownership: which leagues offer it, and on what terms.
 *
 * THE LEAGUE'S OWN WORDS, VERBATIM. These are shown on the owner form under
 * "Important to note", and a buyer reads them as the deal — so they are copied
 * exactly as the league sent them, the price included, and changed only when
 * the league changes them. Not reworded, not tidied, not added to.
 *
 * A league that is not listed here does not take owner registrations, whatever
 * its intake says: the server refuses and the page says so.
 */
export const OWNER_TERMS: Readonly<Record<string, readonly string[]>> = {
  'premier-pearls': [
    'Purchasing a team entitles you to bring four pre-leveled players (owner is included) into your team which must be acceptable according to team ratios.',
    'Owners will choose from existing available team names.',
    'Owners can be singular or have partners.',
    'Should your team win, the prize is awarded to the owner and he/she will decide what happens to it.',
    'Owners are encouraged as well as entitled to gain sponsors for their teams. Sponsored items and cash is then used as the owner deems fit.',
    'Purchase price is R15 000 and is discounted for early bird purchases.',
  ],
};

export const ownerTermsFor = (slug: string | null | undefined): readonly string[] | null =>
  (slug && OWNER_TERMS[slug]) || null;
